import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class InThePress extends ThemeComponent {
    @Ref({ required: false }) quote!: HTMLElement[];
    @Ref({ required: false }) logo!: HTMLElement[];

    init() {

        // Listen for logo clicks
        this.listenForLogoClicks();
    }

    listenForLogoClicks() {
        for (const logo of this.logo) {
            this.$listen(logo, 'click', (e) => {

                // Get item ID
                const itemId = logo.getAttribute('data-item-id');
                if (itemId == null) {
                    this.$log.warn('Logo item ID attribute was null');
                    return;
                }

                // Find quote with matching ID
                for (const quote of this.quote) {
                    const quoteItemId = quote.getAttribute('data-item-id');
                    if (quoteItemId === itemId) {
                        quote.classList.add('in-the-press__quote--active');
                    } else {
                        quote.classList.remove('in-the-press__quote--active');
                    }
                }

                // Toggle logo active class
                for (const otherLogo of this.logo) {
                    if (otherLogo === logo) {
                        otherLogo.classList.add('in-the-press__logo--active');
                    } else {
                        otherLogo.classList.remove('in-the-press__logo--active');
                    }
                }
            });
        }
    }
}
